module.exports = __webpack_public_path__ + "static/media/dflogo.ccbf500a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dflogo.png
// module id = 26
// module chunks = 0